import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { Service } from '../services';
import { GlobalService } from '../global.service';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { AngularFireAnalytics } from '@angular/fire/analytics';
@Component({
  selector: 'app-bills-management',
  templateUrl: './bills-management.component.html',
  styleUrls: ['./bills-management.component.sass']
})
export class BillsManagementComponent implements OnInit {
  public tabActive='Pagos y Facturas';
  isLoading = false;
  public selectBan;
  public banlist;
  public billDueDateField;
  public cycleStartDateField;
  public cycleEndDateField;
  public billBalanceField;
  public cycleDateField;
  public lastPaymentAmountField;
  public amountPayable2;
  public amountPayable;
  public invoiceContent;
  public dopaymentmount;
  public cr='';
  constructor( private router:Router,public appComponent:AppComponent,private loadingScreenService :LoadingScreenService,private services: Service,public global:GlobalService,public AngularFireAnalytics:AngularFireAnalytics) { 
    this.AngularFireAnalytics.setCurrentScreen("Resumen de Factura");
    this.AngularFireAnalytics.logEvent("Resumen de Factura-Screenview");
  }

  ngOnInit() {
    if(this.global.validateSession()==true){
      this.invoiceContent=sessionStorage.getItem("invoiceContentDonwload");
      this.banlist=JSON.parse(atob(sessionStorage.getItem("getAcoout"))).accounts.AccountList;
      this.selectBan=atob(sessionStorage.getItem("selectBan"));
      this.lastPaymentAmountField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.lastPaymentAmountField;
      this.cycleDateField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.cycleDateField;
      this.billBalanceField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.billBalanceField;
      this.cycleEndDateField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.cycleEndDateField;
      this.cycleStartDateField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.cycleStartDateField;
      this.billDueDateField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.billDueDateField;
      this.paymentAmount();
      this.changeBan();
    }
  }
  paymentAmount() {
    if (this.billBalanceField.search('CR') > -1) {
      this.cr = 'CR';
      this.billBalanceField=this.billBalanceField.replace(new RegExp(",","g") ,"");
      this.amountPayable2 = parseFloat(this.billBalanceField).toLocaleString('en-US',{style:'currency', currency:'USD'})+ this.cr;
    }
    else {
      this.cr = '';
      this.billBalanceField=this.billBalanceField.replace(new RegExp(",","g") ,"");
      this.amountPayable = this.billBalanceField;
      this.amountPayable2 = parseFloat(this.amountPayable).toLocaleString('en-US',{style:'currency', currency:'USD'});
    }
    this.checkAmount();
  }
  doPayment(){
    let typeMessage='payment';
    this.global.validateSession();
    let mount = this.amountPayable;
    this.global.newPayment(1,typeMessage,atob(sessionStorage.getItem("selectBan")),atob(sessionStorage.getItem("defaultSubscriber")),mount,atob(sessionStorage.getItem("email")),atob(sessionStorage.getItem("companyName")),"",sessionStorage.getItem("token"));
  }
  checkAmount() {
    this.amountPayable=this.amountPayable2.replace( '$','');
    if(this.amountPayable[0]==0){
      this.amountPayable=this.amountPayable.replace("0","");
    }
    this.amountPayable = this.amountPayable.replace(new RegExp(",","g") ,"");
    if (parseFloat(this.amountPayable) >= 5 && parseFloat(this.amountPayable) <= 99999.99) {
      this.dopaymentmount = true;
    }
    else {
      this.dopaymentmount = false;
    }
  }
  changeBan() {
    this.global.validateSession();
    sessionStorage.setItem("selectBan",btoa(this.selectBan));
    var index = this.banlist.map(function (e) { return e.account; }).indexOf(this.selectBan);
    this.loadingScreenService.startLoading();
      this.services.accountDetails(sessionStorage.getItem("token"),btoa(this.banlist[index].subsriberByDefault),btoa(this.banlist[index].account)).subscribe(data2 =>{
        if(data2.HasError ==false){
          this.loadingScreenService.stopLoading();
          sessionStorage.setItem("getAccountDetails",btoa(JSON.stringify(data2)));
          let actualAccount= JSON.parse(atob(sessionStorage.getItem("getAccountDetails")));
          this.cycleDateField=actualAccount.AccounInfo.cycleDateField;
          this.billDueDateField=actualAccount.AccounInfo.billDueDateField;
          this.billBalanceField=actualAccount.AccounInfo.billBalanceField;
          this.lastPaymentAmountField = actualAccount.AccounInfo.lastPaymentAmountField;
          this.cycleEndDateField = actualAccount.AccounInfo.cycleEndDateField;
          this.cycleStartDateField = actualAccount.AccounInfo.cycleStartDateField;
          this.amountPayable = this.billBalanceField;
          this.paymentAmount();
        }
        else{
          this.global.notif(data2.ErrorDesc);
          this.loadingScreenService.stopLoading();
        }
      });
  }
  fix(num){
    return parseFloat(num).toFixed(2);
  }
}